/**
 * api接口统一管理
 */
 import request from "@/request/http";
 import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据
 
 export function query(data) {
    return request({
        url: "/api/ck.php",
        method: "get",
        params:data
    });
}

 export function uploadImg(data) {
    return request({
        url: "/upload.php",
        method: "post",
				headers:{
					'Content-Type':'application/x-www-form-urlencoded'
				},
				data
    });
}